<template>
  <div class="route-wrapper">
    <div class="spotlight-card">
      <EmailVerificationSuccess v-if="state === 'success'" v-on:goToApollo="onGoToApollo" />

      <EmailVerificationInvalid v-if="state === 'invalid'" />
    </div>
  </div>
</template>

<script>
import EmailVerificationSuccess from "@/components/email-verification/EmailVerificationSuccess";
import EmailVerificationInvalid from "@/components/email-verification/EmailVerificationInvalid";

export default {
  name: 'emailVerification',
  components: {
    EmailVerificationSuccess,
    EmailVerificationInvalid,
  },
  props: {
    state: {
      type: String,
      default: 'initial'
    }
  },
  methods: {
    onGoToApollo: function() {
      location.replace(window.__config__.loginUrl);
    }
  }
};
</script>

<style scoped></style>
